import { render, staticRenderFns } from "./MatchResultsPid.vue?vue&type=template&id=29d34da3&scoped=true&"
import script from "./MatchResultsPid.vue?vue&type=script&lang=js&"
export * from "./MatchResultsPid.vue?vue&type=script&lang=js&"
import style0 from "./MatchResultsPid.vue?vue&type=style&index=0&id=29d34da3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d34da3",
  null
  
)

export default component.exports